import { motion } from "framer-motion";
import { Zap, Shield, Globe, Headphones } from "lucide-react";
const features = [
  { icon: Zap, title: "Fast Processing", description: "Most applications completed within 24-72 hours.", color: "text-amber-500", bg: "bg-amber-50 border-amber-100" },
  { icon: Shield, title: "100% Secure", description: "Bank-grade encryption protects your documents.", color: "text-emerald-500", bg: "bg-emerald-50 border-emerald-100" },
  { icon: Globe, title: "120+ Countries", description: "One platform for every destination worldwide.", color: "text-blue-500", bg: "bg-blue-50 border-blue-100" },
  { icon: Headphones, title: "24/7 Support", description: "Our team is available around the clock.", color: "text-violet-500", bg: "bg-violet-50 border-violet-100" },
];
export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" data-testid="why-choose-us-section" className="py-20 md:py-28 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
          <span className="text-xs tracking-widest uppercase font-semibold text-blue-600 mb-3 block">Why FlyInVisa</span>
          <h2 className="heading-font text-3xl md:text-4xl font-bold text-slate-900">Why Choose Us</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {features.map((f, i) => (
            <motion.div key={f.title} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.1 }} className="card-elevated p-6 group" data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 shrink-0 rounded-xl ${f.bg} border flex items-center justify-center`}>
                  <f.icon className={`w-5 h-5 ${f.color}`} />
                </div>
                <div>
                  <h3 className="heading-font text-base font-semibold text-slate-900 mb-1">{f.title}</h3>
                  <p className="text-sm text-slate-500">{f.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
